import LBox from "@components/LBox";
import LText from "@components/LText";
import useInternetStatus from "@utils/internetStatus";
import React, { useMemo } from "react";
import { Platform, View } from "react-native";
import { FadeInDown } from "react-native-reanimated";
import { useSafeAreaInsets } from "react-native-safe-area-context";

const OfflineBanner = () => {
  const insets = useSafeAreaInsets();

  const bottomMargin = useMemo(() => {
    return Platform.select({
      ios: insets.bottom > 0 ? insets.bottom - 18 : 4,
      android: 0,
    });
  }, [insets.bottom]);

  return (
    <LBox
      flexDirection="row"
      entering={FadeInDown.duration(500)}
      alignItems="center"
      opacity={0.8}
      style={{ marginBottom: bottomMargin, width: "100%" }}
      pointerEvents="none"
      justifyContent="center"
    >
      <LText color="white" variant="bodyM" textAlign="center">
        Offline
      </LText>
    </LBox>
  );
};

const ConnectionChecker = () => {
  const isOnline = useInternetStatus();

  if (isOnline) {
    return null;
  }

  return (
    <View
      style={{
        position: "absolute",
        alignSelf: "center",
        bottom: 0,
        width: "100%",
      }}
      pointerEvents="none"
    >
      <OfflineBanner />
    </View>
  );
};

const neverRerender = () => true;
export default React.memo(ConnectionChecker, neverRerender);
